import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface SchoolJabberUserUpsertState extends ApiState {
  userId?: string
}

export default requestReducer<SchoolJabberUserUpsertState>('SCHOOL_JABBER_USER_UPSERT')
